
<div  align = "center">
    <img src="./assets/img/Foodbudgrey.png" alt="" width = "60">
</div>
<h2 class="h4 mt-0 mb-1 centerAlign" >LOG IN</h2>
<p [tcColor]="'#8f8f90'" class="centerAlign" >Login to access your account</p>

<login-form></login-form>

<p class="mt-5 mb-1"><p class="mt-5 mb-1"><a [routerLink]="['../', 'forgot']">Forgot password click here !</a></p>
<!-- <p>Don't have an account? <a [routerLink]="['../', 'sign-up']">Sign up!</a></p> -->
